import MMS from './MMS';

export { MMS };
export default { MMS };
